import z from 'zod';

export const NotFoundItem = z.object({
    count: z.int(),
    itemId: z.string(),
    name: z.string(),
    reportedOn: z.coerce.date(),
});
export type NotFoundItem = z.infer<typeof NotFoundItem>;
